import { useStore } from '@/store';

type ButtonType = 'btn--primary' | 'btn--secondary';

export default function useButtonEffects() {
  const store = useStore();

  const applyButtonEffects = (buttonType: ButtonType) => {
    const campaignState = store.getters['campaign/state'];
    let buttonEffect = '';
    if (
      campaignState.layout?.buttons?.buttonEffect &&
      buttonType === 'btn--primary' &&
      campaignState.layout?.buttons?.buttonEffect === 'use-global'
    ) {
      buttonEffect = campaignState.layout.buttons.buttonEffect;
      if (
        campaignState.layout?.buttons?.buttonEffect === 'use-global' &&
        campaignState.globalLayout?.buttons?.buttonEffect
      ) {
        buttonEffect = campaignState.globalLayout?.buttons?.buttonEffect;
      }
    }
    if (
      campaignState.layout?.buttons?.secondary?.buttonEffect &&
      buttonType === 'btn--secondary' &&
      campaignState.layout?.buttons?.secondary?.buttonEffect === 'use-global'
    ) {
      buttonEffect = campaignState.layout.buttons.secondary.buttonEffect;
      if (
        campaignState.layout?.buttons?.secondary?.buttonEffect === 'use-global' &&
        campaignState.globalLayout?.buttons?.secondary?.buttonEffect
      ) {
        buttonEffect = campaignState.globalLayout.buttons.secondary.buttonEffect;
      }
    }
    if (
      campaignState.layout?.buttons?.buttonEffect &&
      buttonType === 'btn--primary' &&
      campaignState.layout?.buttons?.buttonEffect !== 'use-global'
    ) {
      buttonEffect = campaignState.layout.buttons.buttonEffect;
    }
    if (
      campaignState.layout?.buttons?.secondary?.buttonEffect &&
      buttonType === 'btn--secondary' &&
      campaignState.layout?.buttons?.secondary?.buttonEffect !== 'use-global'
    ) {
      buttonEffect = campaignState.layout.buttons.secondary.buttonEffect;
    }

    return buttonEffect;
  };

  return {
    applyButtonEffects
  };
}
